<!-- Botón para ver en YouTube -->
<!-- <a [href]="getCurrentYoutubeUrl()" target="_blank" rel="noopener" class="youtube-btn">
  Mirar en <span class="youtube-icon"></span> YouTube
</a> -->
<div class="video-carousel mx-auto position-relative z-0">
  <div class="main-video">
    @for (_ of [iframeRenderId]; track iframeRenderId) {
      @if (currentVideo.videoSrc) {
        <iframe
          style="border-radius: 6px"
          width="100%"
          height="100%"
          [src]="currentVideo.safeVideoSrc"
          title="YouTube video player"
          sandbox="allow-scripts allow-same-origin allow-popups allow-presentation"
          #videoFrame
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
          allowfullscreen
        >
        </iframe>
      } @else {
        <img
          style="border-radius: 6px"
          width="100%"
          height="100%"
          [src]="currentVideo.videoThumbnail"
          [alt]="currentVideo.thumbnailAltText"
        />
      }
    }
  </div>
  @if (transcript) {
    <div class="accordion__container" ngbAccordion>
      <div ngbAccordionItem [collapsed]="true">
        <h2 ngbAccordionHeader class="position-relative">
          <button ngbAccordionButton>
            <h3 class="mb-0 text-gray-900">Transcript</h3>
            <div class="accordion-button-new position-absolute">
              <div class="button-icon position-relative">
                <div class="vertical-line position-absolute"></div>
                <div class="horizontal-line position-absolute"></div>
              </div>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div
                [innerHTML]="
                  videoCarouselData[currentTranscript].transcriptText
                "
              ></div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  }
  @if (videoCarouselData.length > 1) {
    <div class="thumbnials-list__container">
      <div
        class="thumbnails-container d-flex position-relative"
        #scrollContainer
        (scroll)="checkScroll()"
      >
        @for (
          thumbnail of videoCarouselData;
          let i = $index;
          track thumbnail.videoSrc + thumbnail.videoThumbnail + i
        ) {
          <div
            class="thumbnail flex-shrink-0 position-relative"
            (click)="playVideo(i)"
          >
            <img
              width="100%"
              height="auto"
              [src]="thumbnail.videoThumbnail"
              [alt]="thumbnail.thumbnailAltText"
            />
            @if (thumbnail.videoSrc) {
              <div
                class="play-icon position-absolute"
                [class.d-none]="thumbnail.playing"
              >
                <svg
                  width="61"
                  height="62"
                  viewBox="0 0 61 62"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30.0967 1C46.1383 1.00018 59.1924 14.4035 59.1924 31C59.1924 47.5965 46.1383 60.9998 30.0967 61C14.0549 61 1 47.5966 1 31C1 14.4034 14.0549 1 30.0967 1Z"
                    stroke="white"
                    stroke-opacity="0.8"
                    stroke-width="2"
                  />
                  <path
                    d="M43.2344 30.7662L23.187 42.688L23.187 18.8443L43.2344 30.7662Z"
                    fill="white"
                    fill-opacity="0.8"
                  />
                </svg>
              </div>
              <div
                class="now-playing-overlay position-absolute top-0 start-0 h2 text-white d-flex justify-content-center align-items-center"
                [class.playing-now]="thumbnail.playing"
              >
                Now playing
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (!atStart) {
    <div
      class="carousel-button d-flex justify-content-center align-items-center carousel-button--left bg-secondary position-absolute start-0"
      (click)="scrollLeft()"
    >
      <svg
        width="16"
        height="22"
        viewBox="0 0 16 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.717977 11.1571L15.0102 0.896994L15.1235 21.2573L0.717977 11.1571Z"
          fill="white"
        />
      </svg>
    </div>
  }
  @if (!atEnd) {
    @if (videoCarouselData.length > 3) {
      <div
        class="carousel-button d-flex justify-content-center align-items-center carousel-button--right bg-secondary position-absolute end-0"
        (click)="scrollRight()"
      >
        <svg
          width="15"
          height="22"
          viewBox="0 0 15 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.8486 11.2672L0.327376 21.2005L0.675743 0.842832L14.8486 11.2672Z"
            fill="white"
          />
        </svg>
      </div>
    }
  }
</div>
